export const models = {
  status: null
};
export const options = {
  statusOptions: []
};

export const Fields = [
  {
    type: "text",
    name: "note",
    label: "Note",
    value: "",
    rules: "required",
    validationMessage: {
      required: "Note is required"
    },
    xl: "12"
  },
  {
    type: "select",
    name: "status",
    label: "status",
    value: "",
    rules: "required",
    options: [],
    validationMessage: {
      required: "Select type please"
    },
    xl: "12"
  }
];
